import { FirebaseConnection, FunctionsRepository, DataCallback } from '../Infrastractures';
import { FunctionTypes } from '../Enums/FunctionTypes';
import { Function, Functions } from '../Entities/Function';
import { ThreadRepository } from '../Infrastractures/ThreadRepository';
import { Post } from '../Entities/Chat/Post';
import { PostFactory } from '../Entities/Chat/PostFactory';
import { DummyPlainObject } from '../Entities/Chat/Post';

export class DataInitializeUsecase {
  private _functionsRepository: FunctionsRepository;
  private _functions: Functions = new Functions();
  private _threadRepositories: DummyPlainObject[] = [];

  public constructor(private firebaseConnection: FirebaseConnection) {
    this._functionsRepository = new FunctionsRepository(firebaseConnection);
  }

  private get functionsRepository(): FunctionsRepository {
    if (!this._functionsRepository) {
      this._functionsRepository = new FunctionsRepository(this.firebaseConnection);
    }
    return this._functionsRepository;
  }

  public get functions(): Functions {
    return this._functions;
  }
  
  public get threadRepositories(): DummyPlainObject[] {
    return this._threadRepositories;
  }

  private promises: Promise<boolean>[] = [];

  public async getFunctionAll() {
    const self: DataInitializeUsecase = this;

    const callback = new class implements DataCallback {
      public async setData(id: string, data: any | Functions): Promise<boolean> {
        const isFunctions = (data: any): data is Functions => data.lastupdate !== undefined;
        if(isFunctions(data)) {
          self._functions = data;
          return false ;
        }

        const func: Function<Post> = FunctionTypes.getInstance(data.type, {
          id: id, name: data.name, type: data.type
        });
        self.functions.add(func);
      
        const repository = ThreadRepository.getInstance(func, func.id, self.functionsRepository);
        self.threadRepositories.push(repository)
        await self.getChildren(repository, func)

        return true;
      }
    }();
    await this.functionsRepository.getAll(callback);

    return true;
  }

  public async getChildren(repository: ThreadRepository, parent: Function<Post> | Post): Promise<boolean>  {
    const self: DataInitializeUsecase = this;
    const uid = this.firebaseConnection.authUid;
    const callback = new class implements DataCallback {
      public async setData(id: string, data: any): Promise<boolean> {
        if (!data.contents && !data.user_uids) return false;
        const post = PostFactory.getInstance(id, data);

        if (data.hasOwnProperty('user_uids')
          && !data.user_uids.includes(uid)) {
          return false;
        }

        const postList = parent.postList;
        postList.add(post);
          
        if (!post.hasChildren() || !repository.hasChildRepository()) {
          //console.log(this, 'setData')
          self.functionsRepository.save(self.functions);
          return true;
        }

        const childRepository = repository.childRepository(id);
        self.threadRepositories.push(childRepository);

        await self.getChildren(childRepository, post);

        return true;
      }
    }();
    await repository.getAll(callback);

    return true;
  }
}
